import { useQuery } from '@tanstack/react-query';
import { workspaceService } from '../services/workspaceService';

export function useWorkspaces() {
  return useQuery({
    queryKey: ['workspaces'],
    queryFn: async () => {
      const response = await workspaceService.listWorkspaces();
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch workspaces');
      }
      return response.data ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
